import { render, staticRenderFns } from "./PosSetting.vue?vue&type=template&id=521bbddc&scoped=true&"
import script from "./PosSetting.vue?vue&type=script&lang=js&"
export * from "./PosSetting.vue?vue&type=script&lang=js&"
import style0 from "./PosSetting.vue?vue&type=style&index=0&id=521bbddc&prod&lang=css&"
import style1 from "./PosSetting.vue?vue&type=style&index=1&id=521bbddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521bbddc",
  null
  
)

export default component.exports